import React, { useRef, useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TextWIthToolTip = ({ text, question = false }) => {
    const [placement, setPlacement] = useState("top");
    const targetRef = useRef(null);

    function renderTextWithLinks(text) {
        if(!text || !text.replace ) return ;
        let safeText = text.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
                       .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '');

        return safeText;
    }


    useEffect(() => {
        const handleWindowResize = () => {
            try{
                const { top } = targetRef.current.getBoundingClientRect();
                const scrollTop = window.scrollY || window.pageYOffset;
                const offsetTop = top + scrollTop;
                const tooltipHeight = 150; // Approximate height of the tooltip
    
                if (offsetTop < tooltipHeight) {
                    setPlacement("bottom");
                } else {
                    setPlacement("top");
                }
            }catch{}
        };

        handleWindowResize(); // Initial check

        window.addEventListener("resize", handleWindowResize);
        window.addEventListener("scroll", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
            window.removeEventListener("scroll", handleWindowResize);
        };
    }, []);

    return (
        <OverlayTrigger
            placement={placement}
            overlay={
                <Tooltip className="access-tooltip access-text-tooltip-jq">
                    {text}
                </Tooltip>
            }
        >
            <span
                className={question ? "text-break" : ""}
                style={{ whiteSpace: question ? "" : "pre-wrap" }}
                ref={targetRef}
                {...(question
                    ? { dangerouslySetInnerHTML: { __html: renderTextWithLinks(text) } }
                    : { children: text }
                )}
            />
        </OverlayTrigger>
    );
};

export default React.memo(TextWIthToolTip);

